"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Num {
    static truncate(value, decimals) {
        const factor = Math.pow(10, decimals);
        return (Math.floor(value * factor) / factor).toFixed(decimals);
    }
    static compact(value) {
        if (value >= 1000000) {
            return `${(value / 1000000).toFixed(2).replace(/\.?0+$/, "")}M`;
        }
        if (value >= 1000) {
            return `${(value / 1000).toFixed(2).replace(/\.?0+$/, "")}K`;
        }
        return value.toString();
    }
}
exports.default = Num;
